import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Firebase configuration
// Replace these values with your Firebase project settings
// Get them from: Firebase Console → Project Settings → General → Your apps
const firebaseConfig = {
  apiKey: "AIzaSyA1Sl1rnBr5mwczXAhypA4YhF6Ag2D__I0",
  authDomain: "gloss-hub-8dc44.firebaseapp.com",
  projectId: "gloss-hub-8dc44",
  storageBucket: "gloss-hub-8dc44.firebasestorage.app",
  messagingSenderId: "857582420218",
  appId: "1:857582420218:web:a5d8a64990407eaf8c4943"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export auth and provider
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// IMPORTANT: For redirect flow, Firebase will redirect back to the current page
// The redirect result MUST be processed BEFORE the app redirects away
// We removed custom parameters that could interfere with mobile

export default app;